import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionSectionService } from '../../shared/services/index';
import { InspectionSection } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';
import { zip } from 'rxjs/operators';

@Component({
    templateUrl: './edit.component.html',
    standalone: false
})
export class SectionEditPageComponent extends BaseModalPageComponent implements OnInit {
  section: InspectionSection;
  inspectionId: string;
  sectionId: string;
  public processing = false;

  constructor(
    public sectionService: InspectionSectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = sectionId;
      this.initData();
    });
  }

  saveInspectionSection(section: InspectionSection): void {
    this.processing = true;
    this.sectionService
      .updateProperties(section.inspection.id, section.id, { name: section.name, description: section.description })
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel(): void {
    this.goToBack();
  }

  initData(): void {
    this.sectionService.getSection(this.inspectionId, this.sectionId).subscribe((el) => {
      this.section = el;
      this.cdf.detectChanges();
    });
  }
}
